'use client';
import { INinjaEvent, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import { KissanEventType } from '../utils/eventConstants';

// SSR-safe checkLocationPermission
export const checkLocationPermission = async () => {
  // If running on the server, do nothing or return a default
  // if (typeof window === 'undefined') {
  //   return false;
  // }

  // Dynamically import only on the client
  const Location = await import('expo-location');
  const { Linking, Platform } = await import('react-native');

  const processEvents = (useQueuedEventStore.getState()).processEvents;

  const handleLocationPopupEvent = (eventName: string) => {
    const locationPopupEvent: INinjaEvent = {
      name: eventName,
      screenDetails: { screen: 'location page' },
    };
    processEvents([locationPopupEvent]);
  };

  try {
    handleLocationPopupEvent(KissanEventType.LOCATION_POPUP_OPEN);

    const permissionStat = await Location.requestForegroundPermissionsAsync();
    if (permissionStat.status === 'granted') return true;
    handleLocationPopupEvent(KissanEventType.LOCATION_POPUP_CLOSE);
    let status: any = permissionStat.status;
    console.log('status', status);
    if (Platform.OS === 'ios' && status === 'denied') {
      handleLocationPopupEvent(KissanEventType.LOCATION_POPUP_CLOSE);
      Linking.openURL('app-settings:');
    } else if (Platform.OS === 'android' && status === 'denied') {
      handleLocationPopupEvent(KissanEventType.LOCATION_POPUP_CLOSE);
      Linking.openSettings();
    }
    return status === 'granted';
  } catch (error) {
    console.error('Error checking location permission:', error);
    return false;
  }
};
